import { Component } from '@angular/core';

@Component({
  selector: 'app-documents-icon-svg',
  standalone: true,
  template: `<svg
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.1875 12.3125H8.81246V11.1875H3.1875V12.3125ZM3.1875 9.31246H8.81246V8.1875H3.1875V9.31246ZM1.73077 15.125C1.35193 15.125 1.03125 14.9937 0.76875 14.7312C0.50625 14.4687 0.375 14.148 0.375 13.7692V2.23077C0.375 1.85192 0.50625 1.53125 0.76875 1.26875C1.03125 1.00625 1.35193 0.875 1.73077 0.875H7.6875L11.625 4.81246V13.7692C11.625 14.148 11.4937 14.4687 11.2312 14.7312C10.9687 14.9937 10.648 15.125 10.2692 15.125H1.73077ZM7.125 5.37496V1.99998H1.73077C1.67308 1.99998 1.62018 2.02402 1.57209 2.07209C1.52402 2.12018 1.49998 2.17307 1.49998 2.23077V13.7692C1.49998 13.8269 1.52402 13.8798 1.57209 13.9279C1.62018 13.9759 1.67308 14 1.73077 14H10.2692C10.3269 14 10.3798 13.9759 10.4279 13.9279C10.4759 13.8798 10.5 13.8269 10.5 13.7692V5.37496H7.125Z"
      fill="#1C1B1F"
    />
  </svg> `,
})
export class DocumentsIconSvgComponent {}
